export enum ShipmentType {
  NOTINUSE1 = 0,
  NOTINUSE2 = 1,
  NOTINUSE3 = 2,
  Shipment = 3,
  Service = 4,
  COMPANION = 5
}
